// extracted by css-extract-rspack-plugin
export default {"scrollableShortcuts":"src-wab-client-components-studio-Shortcuts-module__scrollableShortcuts-UUEK1H","searchInput":"src-wab-client-components-studio-Shortcuts-module__searchInput-hqodJU","shortcutRow":"src-wab-client-components-studio-Shortcuts-module__shortcutRow-TMIP6G"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"scrollableShortcuts\":\"src-wab-client-components-studio-Shortcuts-module__scrollableShortcuts-UUEK1H\",\"searchInput\":\"src-wab-client-components-studio-Shortcuts-module__searchInput-hqodJU\",\"shortcutRow\":\"src-wab-client-components-studio-Shortcuts-module__shortcutRow-TMIP6G\"}";
        // 1793541991341
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  